<template>
  <div
    id="app"
    class="app u-full-vp-height u-full-vp-width u-overflow-hidden"
    :class="{ 'app--started': started }"
  >
    <transition name="t-fader" mode="in-out">
      <station class="app__station" v-if="started"/>
      <cover class="app__cover" v-else @start="started = true"/>
    </transition>
    <div ref="containerCSS3D" class="u-wrapper-panel u-overflow-hidden u-pointer-none" />
    <!-- <div class="title u-pointer-none">
      <div class="title__main">La RATP vous protège</div>
      <div class="title__content">Immergez vous dans<br />nos actions anti Covid-19</div>
    </div> -->
  </div>
</template>

<script>
import App from './App'

import Station from '@/views/Station'
import Cover from '@/views/Cover'

export default {
  name: 'App',

  mixins: [App],

  components: {
    Station,
    Cover
  },

  data () {
    return {
      started: false
    }
  },

  mounted () {
    this.$dom3d.attachTo(this.$refs.containerCSS3D)
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<style lang="stylus">

.title
  position fixed
  top 10px
  left 10px
  z-index 10

  &__main
    color #00a994
    font-size 30px
    font-weight 800

  &__content
    color #000000
    font-size 15px
    font-weight 800

  &__cover
    z-index 1000

  &__cover, &__station
    width 100%
    height 100%
    top 0
    left 0
    position absolute

.app
  &::after
    content ''
    width 100%
    height 100%
    top 0
    left 0
    border 0 solid rgb(62, 72, 245)
    position absolute
    transition .4s .2s
    z-index 2001
    pointer-events none

  &:active::after, &--started::after
    border-width 7px
    transition .1s
</style>
